export const FETCH_DIAGNOSIS_SUCCESS = 'FETCH_DIAGNOSIS_SUCCESS';
export const FETCH_DIAGNOSIS_FAILED = 'FETCH_DIAGNOSIS_FAILED';
export const FETCH_DIAGNOSIS_START = 'FETCH_DIAGNOSIS_START';

export const UPDATE_DIAGNOSIS_LIST = 'UPDATE_DIAGNOSIS_LIST';
